// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ais-ClearRefinements-button {
  color: black;
  text-decoration: underline;
  padding: 2px 10px;
  background-color: transparent;
  border: 1px solid black;
  font-size: 0.6875rem;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/page/components/search-page/components/clear-refinements/clear-refinements.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,6BAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;AACF","sourcesContent":[".ais-ClearRefinements-button {\n  color: black;\n  text-decoration: underline;\n  padding: 2px 10px;\n  background-color: transparent;\n  border: 1px solid black;\n  font-size: 0.6875rem;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
